export default "__VITE_ASSET__CNem5Etr__ 720w";